export const PSEUDO_CITY = 'PseudoCity';
export const STATION = 'Station';